import React from 'react';
import '../styles/Help.css';
import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function Help () {

    const [openComp, setCompOpen] = React.useState(false);
    const handleOpenCompTool = () => setCompOpen(true);
    const handleCloseCompTool = () => setCompOpen(false);

    const [openFieldDetails, setFieldDetails] = React.useState(false);
    const handleOpenFieldDetails = () => setFieldDetails(true);
    const handleCloseFieldDetails = () => setFieldDetails(false);

    const [openAudit, setAuditOpen] = React.useState(false);
    const handleOpenAuditTool = () => setAuditOpen(true);
    const handleCloseAuditTool = () => setAuditOpen(false);

    const [openExport, setExportOpen] = React.useState(false);
    const handleOpenExportTool = () => setExportOpen(true);
    const handleCloseExportTool = () => setExportOpen(false);


    const modalStyle = {
        boxShadow: 24,
    };

    return (
        <div>
            <span className="HelpArea">
                <h1>
                    HOW TO FORMAT TO USE THE CENSUS TOOL CORRECTLY
                </h1>
                <span>
                    <br/>
                </span>
                <h2>
                    1: Name the worksheet you intend to pull data from 'Census' or 'CoreToolCensus' for the new core tool import
                </h2>
                <span>
                    <br/>
                </span>
                <h3>
                    2: Delete any rows above the column headers
                </h3>
                <span>
                    <br/>
                </span>
                <p>
                    To reduce variation, try to ensure the sheet begins with the first column header in A1.
                </p>
                <span>
                    <br/>
                </span>
                <p>
                    Sometimes the format they send is weird, so copying the
                    sheet to a new blank one can help.
                </p>
                <span>
                    <br/>
                </span>
                <h4>
                    3: You must name your columns specific EXACT terms or it will leave any fields that
                    require that value blank.
                </h4>
                <span>
                    <br/>
                </span>
                <h5>
                    The Column names it looks for are as follows:
                </h5>
                <span>
                    <br/>
                </span>
                <span className="ColumnNames">
                    SSN   ||    ESSN - (Employee SSN)   ||   Relationship    ||    First Name    ||    Middle Name    ||    Last Name    ||    Prefix    ||    Suffix
                </span>
                <span>
                    <br/>
                </span>
                <span className="ColumnNames">
                    DOB   ||    Alt ID   ||   Unique ID    ||    Address    ||    Address 2    ||    City    ||    State    |
                    |    Zip Code    ||    Home Phone    ||    Work Phone    ||    Fax    ||    Email    ||    Ethnicity - Input Codes
                </span>
                <span>
                    <br/>
                </span>
                <span className="ColumnNames">
                    Death Date   ||    Sex   ||   Marital Status - Input Codes    ||    Handicap    ||    Hire Date    ||    Terminated Date    ||    Enrolled Date    |
                    |    Disenroll Date    ||    Group ID    ||    Location    ||    Tier    ||    Plan1 through Plan15
                </span>
                <span>
                    <br/>
                </span>
                <div className="helpButton">
                    <Button onClick={handleOpenFieldDetails} className='modalButton'>Column Details</Button>
                </div>
                <Modal
                    open={openFieldDetails}
                    onClose={handleCloseFieldDetails}
                    aria-labelledby="FieldsTitle"
                    aria-describedby="FieldsDescription"
                >
                    <Box sx={modalStyle} className='ModalStyles'>
                      <Typography id="FieldsTitle" variant="h6" component="h2">
                        Column Header Specifics
                      </Typography>
                      <Typography id="FieldsDescription" sx={{mt: 2}}>
                        Relationship - It should be "Employee"/"Self"/"EE", "Spouse"/"SP", or "Child"/"CH"/"ChildX"(up to Child15) in this field, case does not matter
                      </Typography>
                      <Typography id="FieldsDescription" sx={{mt: 2}}>
                        Tier - Takes either the codes(ESP, EMP, FAM, ECH) or will convert Employee/Employee
                        Only/Self/EE/EM (to EMP), Spouse/Employee + Spouse/ES (to ESP), Children/Employee +
                        Children/Employee + Child(ren)/Employee + Child/Child(ren)/Child/EC (to ECH), Family/Employee +
                        Family/EF (to FAM). Since a member's different plans can have different tiers, if that is the case then you can use columns Tier1 - Tier15 for each plan
                        instead
                      </Typography>
                      <Typography id="FieldsDescription" sx={{mt: 2}}>
                        Dates - Format them YYYYMMDD or MM/DD/YYYY (including slashes, leading zeros aren't necessary) or leave it as the numeric value for dates Excel creates
                        (can be manually done by giving dates in a column the general format).
                      </Typography>
                      <Typography id="FieldsDescription" sx={{mt: 2}}>
                        Plans - Fill these with Plan IDs. It will check for a field of each plan column and create an eligibility record for members with a Plan ID in the column.
                        Create these in order Plan1-15 or it will stop once it can't find a field in the sequence.
                      </Typography>
                      <Typography id="FieldsDescription" sx={{mt: 2}}>
                        If it can't get something correct you can always leave the column
                        out and it will skip any fields that require it. Keep in mind if there is no
                        column it could mistakenly match on a name later if you miss it.
                      </Typography>
                    </Box>
                </Modal>
                <span>
                    <br/>
                </span>
                <p>
                    Once the excel is saved and ready you can simply open it from your downloads.
                </p>
                <span>
                    <br/>
                </span>
                <p>
                    It names the file VBA_CommonCensus + whatever the file you input was named so rename it first if you wanna skip doing that later.
                </p>
                <span>
                    <br/>
                </span>
                <p>
                    IF IT ERRORS ON SOMETHING it can be a sign of an unexpected data type incoming so feel free to ask Alex R about it.
                </p>
                <div className="helpButton">
                    <span className="ButtonAlignment">
                    {/*    <Button onClick={handleOpenCompTool} className='modalButton compButton' >85/93 COMPARISON</Button>*/}
                        {/*<Modal*/}
                        {/*    open={openComp}*/}
                        {/*    onClose={handleCloseCompTool}*/}
                        {/*    aria-labelledby="CompTitle"*/}
                        {/*    aria-describedby="CompDescription"*/}
                        {/*>*/}
                        {/*    <Box sx={modalStyle} className='ModalStyles'>*/}
                        {/*      <Typography id="CompTitle" variant="h6" component="h2">*/}
                        {/*        FOR THE 85/93 COMPARISON TOOL*/}
                        {/*      </Typography>*/}
                        {/*      <Typography id="CompDescription" sx={{mt: 2}}>*/}
                        {/*        1. Combine the old and new sheet into one workbook.*/}
                        {/*      </Typography>*/}
                        {/*      <Typography id="CompDescription" sx={{mt: 2}}>*/}
                        {/*        2. Name the sheets OldSheet and NewSheet.*/}
                        {/*      </Typography>*/}
                        {/*      <Typography id="CompDescription" sx={{mt: 2}}>*/}
                        {/*        3. Drag and Drop your saved sheet.*/}
                        {/*      </Typography>*/}
                        {/*    </Box>*/}
                        {/*</Modal>*/}
                        <Button onClick={handleOpenAuditTool} className='modalButton'>MEMBER AUDIT TOOL</Button>
                    <Modal
                        open={openAudit}
                        onClose={handleCloseAuditTool}
                        aria-labelledby="AuditTitle"
                        aria-describedby="AuditDescription"
                    >
                        <Box sx={modalStyle} className='ModalStyles'>
                          <Typography id="AuditTitle" variant="h6" component="h2">
                            FOR THE MEMBER AUDIT TOOL
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            This tool checks for members missing on either based on social security number and first and last names.
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            1. Combine the old and new sheet into one workbook.
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            2. Name the sheets OldMembers and NewMembers.
                          </Typography>
                            <Typography id="AuditDescription" sx={{mt: 2}}>
                            3. Name the comparison columns "SSN", "First Name", and "Last Name".
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            4. Drag and Drop your saved sheet.
                          </Typography>
                        </Box>
                    </Modal>

                    </span>
                </div>
                <div className="helpButton">
                    <Button onClick={handleOpenExportTool}
                            className='modalButton2'>WEEKLY ELIGIBILITY & ACCUMS</Button>
                    <Modal
                        open={openExport}
                        onClose={handleCloseExportTool}
                        aria-labelledby="AuditTitle"
                        aria-describedby="AuditDescription"
                    >
                        <Box sx={modalStyle} className='ModalStyles'>
                          <Typography id="AuditTitle" variant="h6" component="h2">
                            FOR THE WEEKLY ELIGIBILITY & ACCUM FILES SHEET NAMES
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Transparent - Transparent
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            ImagineMD - IMG
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            H2B - H2B
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Evolutions - Evolutions
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Concierge Nursery Navigators - CNN
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            EHIM Accumulators - EHIMAccum
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            AMPS - AMPS
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Fairscripts - FS
                          </Typography>
                            <Typography id="AuditDescription" sx={{mt: 2}}>
                            DisclosedRX - DRX
                          </Typography>
                            <Typography id="AuditDescription" sx={{mt: 2}}>
                            Healthbus - Healthbus
                          </Typography>
                            <Typography id="AuditDescription" sx={{mt: 2}}>
                            United Concierge - United
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Medefy - Medefy
                          </Typography>
                          <Typography id="AuditDescription" sx={{mt: 2}}>
                            Medefy Accumulators - MedefyAccums(must include the eligibility sheet for Accums)
                          </Typography>
                        </Box>
                    </Modal>
                </div>
            </span>
        </div>
)
}